import { Box } from '@mui/material'
import TeamSelect from '../../../components/editors/select/TeamSelect'
import { useCallback } from 'react'
import { useProjectPrivateContext } from '../../../context/projectContext'

type Props = {
  teamUuid?: string
  setTeamUuid: (teamUuid: string) => void
}

export const TeamSelector = ({ teamUuid, setTeamUuid }: Props) => {
  const { project } = useProjectPrivateContext()
  const onTeamChanged = useCallback(
    (teamUuid: string) => {
      setTeamUuid(teamUuid)
    },
    [setTeamUuid]
  )
  return (
    <Box
      sx={{
        margin: '10px 10px 0',
        padding: '10px',
        backgroundColor: '#D8DDE54D',
        display: 'flex',
        flexFlow: 'column',
        gap: '8px',
      }}
    >
      <TeamSelect
        projectUuid={project.uuid}
        onTeamChanged={onTeamChanged}
        teamUuid={teamUuid}
      ></TeamSelect>
    </Box>
  )
}
